// extracted by mini-css-extract-plugin
module.exports = {"countdownToRecord":"countdownToRecord_countdownToRecord__1_C-A"};